<script>
import EventSession from '@components/List/EventSession'
import formatDate from '@utils/format-date'
import { FAKE_EVENT_ITEM, FAKE_SESSION_ITEM } from '@src/config/fake-evnet'

export default {
  components: {
    EventSession,
  },
  props: {
    eventItem: {
      type: Object,
      default: () => {
        return FAKE_EVENT_ITEM
      },
    },
    sessionList: {
      type: Array,
      default: () => {
        return FAKE_SESSION_ITEM
      },
    },
  },
  data() {
    return {
      coursesActiveTab: '0',
    }
  },
  // created() {
  //   console.log('eventItem :>> ', this.eventItem)
  //   console.log('this.sessionList :>> ', this.sessionList)
  // },
  methods: {
    formatDate,
    onApply(val) {
      this.$emit('apply', val)
    },
    filterIsFull(date) {
      const isFull = date.filter((item) => {
        return item.isFull === 1
      })
      if (isFull.length === date.length) return true
      else return false
    },
  },
}
</script>

<template>
  <div>
    <el-select v-model="coursesActiveTab" class="isStyleMenu isCenter mb-4 d-md-none" :class="{ 'd-none': sessionList.length === 1 }" popper-class="isStyleMenu isCenter">
      <template v-for="(sessionItem, index) in sessionList">
        <el-option :key="index" :label="formatDate(sessionItem.date, 'yyyy/MM/dd')" :value="`${index}`"></el-option>
      </template>
    </el-select>
    <el-tabs v-model="coursesActiveTab" class="isStyleBase isStyleEvent" :class="{ isHiddenHead: sessionList.length === 1 }" stretch>
      <el-tab-pane v-for="(sessionItem, index) in sessionList" :key="index" :name="`${index}`">
        <span slot="label">
          <el-tag v-if="filterIsFull(sessionItem.sessions)" class="isStylePurple isSmall isRadius mr-2">已額滿</el-tag>
          <span v-html="formatDate(sessionItem.date, 'yyyy/MM/dd')"></span>
        </span>
        <EventSession :event-item="eventItem" :session-item="sessionItem" type="event" @apply="onApply" />
      </el-tab-pane>
    </el-tabs>
    <!-- <el-tabs v-model="coursesActiveTab" class="isStyleBase isStyleEvent" :class="{ isHiddenHead: sessionList.length === 1 }" stretch>
      <el-tab-pane v-for="(sessionItem, index) in sessionList" :key="index" :label="'<p>123</p>' + formatDate(sessionItem.date, 'yyyy/MM/dd')" :name="`${index}`">
        <EventSession :event-item="eventItem" :session-item="sessionItem" type="event" @apply="onApply" />
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>
<style lang="scss" module>
.sectionCourseAbout {
  :global {
    .sectionCourseAbout {
    }
  }
}

.courseAbout {
  background-color: $color-gray-2;
  box-shadow: 0 2px 10px rgba(33, 69, 88, 0.16);

  :global {
    .col-md {
      display: flex;
      align-items: center;
    }

    .courseAbout {
      &__info {
        padding-top: 3.75rem;
        padding-right: 3rem;
        padding-bottom: 3.75rem;
        padding-left: 3rem;
        background-color: #fff;

        @include max-sm {
          padding: 2.5rem 2rem;
        }
      }

      &__content {
        // display: flex;
        // align-items: center;
        width: 100%;
        padding: 2rem;
        line-height: 2;
        //  display: flex;
        //  flex-wrap:wrap;
        //  align-items: center;
        // background-color: $color-gray-2;
      }
    }
  }
}
</style>
